import { render, staticRenderFns } from "./ResultsAccordionBody.vue?vue&type=template&id=71c5e4b4&scoped=true&"
import script from "./ResultsAccordionBody.vue?vue&type=script&lang=js&"
export * from "./ResultsAccordionBody.vue?vue&type=script&lang=js&"
import style0 from "./ResultsAccordionBody.vue?vue&type=style&index=0&id=71c5e4b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c5e4b4",
  null
  
)

export default component.exports